import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import MainLoader from "../components/sub/MainLoader";

function AppRoute() {
  const userState = useSelector((state) => state.userState.value);
  const firstLoginState = useSelector((state) => state.firstLoginState.value);
  const setupAccountState = useSelector(
    (state) => state.setupAccountState.value
  );
  const positionState = useSelector((state) => state.positionState.value);

  if (userState.username) {
    if (firstLoginState) {
      return <Navigate to={"/setup-profile"} replace />;
    } else if (!setupAccountState) {
      return <Navigate to={"/setup-account"} replace />;
    } else if (!positionState) {
      return <Navigate to={"/not-found"} replace />;
    } else {
      return <Outlet />;
    }
  }
  return <MainLoader />;
}

export default AppRoute;
